import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Login from "@/modules/Auth/pages/Login";
import NotFound from "@/modules/Auth/pages/NotFound";
import Recover from "@/modules/Auth/pages/Recover";
import SetPassword from "@/modules/Auth/pages/SetPassword";

function AuthRoutes(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") return navigate("/login");

    if (
      location.pathname !== "/login" &&
      location.pathname !== "/recover" &&
      location.pathname !== "/set-password"
    ) {
      return navigate(`/login?origin=${location.pathname}`);
    }
    //eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/recover" element={<Recover />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AuthRoutes;
